import { render, staticRenderFns } from "./mod2CustomerProfile.vue?vue&type=template&id=5bc8b828"
import script from "./mod2CustomerProfile.vue?vue&type=script&lang=js"
export * from "./mod2CustomerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports